import { ReactPortal } from 'react';
import { createPortal } from 'react-dom';
import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';
import { PropPortal } from './PropsPortal';
import classNames from 'classnames';

import styles from './Portal.module.scss';

export default function ClientOnlyPortal({ children, isOpen }: PropPortal): ReactPortal | null {
  const modalRoot = document.getElementById('portal');
  return modalRoot
    ? createPortal(
        <ErrorBoundaryComponent>
          <div className={classNames(styles.Wrapper, isOpen && styles.Active)}>{children}</div>
        </ErrorBoundaryComponent>,
        modalRoot,
      )
    : null;
}
